var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-16"},[_c('Navbar',{attrs:{"title":"协议"}}),_c('div',{staticClass:"font-16 fw-500 mb-24"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }